var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSend = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "send",
    clipPath: "url(#clip0_83325_18279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.83335 20.5266L17.375 13.0184C18.05 12.6671 18.05 11.5228 17.375 11.1715L2.83335 3.66332C2.28335 3.37223 1.67502 3.86408 1.67502 4.57675L1.66669 9.20411C1.66669 9.70599 1.97502 10.1376 2.39169 10.1978L14.1667 12.095L2.39169 13.982C1.97502 14.0523 1.66669 14.4839 1.66669 14.9858L1.67502 19.6132C1.67502 20.3258 2.28335 20.8177 2.83335 20.5266Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_83325_18279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24.0904,
    fill: "white",
    transform: "translate(0 0.0488281)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSend);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/send.d8f00593df807d4bba4b83eda52d7997.svg";